
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 06/08/2025
 * @update 06/08/2025
 * @file src/components/W06/W06F2520
 */

import Api from "../../../services/api";
import * as types from "../../types";

export function loadDecimalSetting(cb) {
    return async (dispatch) => {
        await Api.get('/W06F2520/get-setting')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadDecimalSettingComplete(result.data));
                }
            });
    };
};

function loadDecimalSettingComplete(data) {
    return {
        type: types.W06_W06F2520_LOAD_DECIMAL_SETTING_COMPLETE,
        data
    };
};

export function loadCombo(params, cb) {
    return async () => {
        await Api.put('/W06F2520/load-cbo-dropdown', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCboWareHouse(params, cb) {
    return () => {
        Api.put('/w17f5560/get-cbo-warehouse', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadMaster(params, cb) {
    return async () => {
        await Api.put('/W06F2520/load-master', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadDetail(params, cb) {
    return async () => {
        await Api.put('/W06F2520/load-detail', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadVoucher(params, cb) {
    return async () => {
        await Api.put('/W06F2520/load-voucher', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadAttachment(params, cb) {
    return async () => {
        await Api.put('/W06F2520/load-attached', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadPovInv(params, cb) {
    return async () => {
        await Api.put('/W06F2520/load-PovInv', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onChoose(params, cb) {
    return async () => {
        await Api.post('/W06F2520/choose', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function checkEdit(params, cb) {
    return async () => {
        await Api.put('/W06F2520/check-edit', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onPrint(params, cb) {
    return async () => {
        await Api.put('/W06F2520/print', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onSave(params, cb) {
    return async () => {
        await Api.post('/W06F2520/save', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCboPriceList(param, cb) {
    return () => {
        Api.put('/w17f2000/load-currency', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCboObjectVAT(params, cb) {
    return () => {
        Api.put('/w17f2040/load-object-VAT', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function approval(param, cb) {
    return () => {
        Api.put('/W06F2520/approval', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function calculateRateAmount(params, cb) {
    return () => {
        Api.post('/W06F2520/rate-amount', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function paymentRequest(params, cb) {
    return () => {
        Api.post('/W06F2520/payment-request', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function updateStatus(params, cb) {
    return () => {
        Api.put('/W06F2520/update-status', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}